import { render, staticRenderFns } from "./PropagateEdit.vue?vue&type=template&id=5b193048&scoped=true"
import script from "./PropagateEdit.vue?vue&type=script&lang=js"
export * from "./PropagateEdit.vue?vue&type=script&lang=js"
import style0 from "./PropagateEdit.vue?vue&type=style&index=0&id=5b193048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b193048",
  null
  
)

export default component.exports